export default __webpack_public_path__ + "static/media/farzad.fb6323ec.jpeg";